/** localStorage / sessionStorage access that never throws (private mode, blocked storage, SSR). */
function make(getter: () => Storage) {
  return {
    get(key: string): string | null {
      try {
        return getter().getItem(key);
      } catch {
        return null;
      }
    },
    set(key: string, value: string): void {
      try {
        getter().setItem(key, value);
      } catch {
        /* storage unavailable — ignore */
      }
    },
    remove(key: string): void {
      try {
        getter().removeItem(key);
      } catch {
        /* storage unavailable — ignore */
      }
    },
  };
}

export const storage = make(() => window.localStorage);
export const sessionStore = make(() => window.sessionStorage);

export const STORAGE_KEYS = {
  refreshToken: 'tp.refreshToken',
  theme: 'tp.theme',
  lang: 'tp.lang',
  orgId: 'tp.orgId',
  reviewAutoAdvance: 'tp.review.autoAdvance',
  gapThreshold: 'tp.gapThreshold',
  launchUrl: (executionId: string) => `tp.launch.${executionId}`,
} as const;
